import { useIsBrandLive } from "@/lib/socket";
import { POLL_SOCKET_SAFETY_MS } from "@/lib/realtime";
import { useWorkspaceStore } from "@/stores/workspaceStore";

/**
 * True while the calendar's brand (the selected one) is live on the socket:
 * every calendar write then arrives as a realtime hint (calendarRealtime.ts),
 * and the reads only poll as a safety net.
 */
export function useCalendarLive(): boolean {
  const brandId = useWorkspaceStore((s) => s.selectedBrandId);
  return useIsBrandLive(brandId);
}

/**
 * A calendar read's poll: the slow safety net while live, otherwise its own
 * cadence (the planPolling predicates). A read that has stopped for good
 * (`false`, e.g. an archived month) stays stopped either way.
 */
export function livePoll(live: boolean, fallback: number | false): number | false {
  if (fallback === false) return false;
  return live ? POLL_SOCKET_SAFETY_MS : fallback;
}
